export default "assets/images/flags/cn-05768932.svg";